<template>
  <div class="game-container">
    <table @click="resetCheckStatus">
      <tr v-for="(row, i) in diagram" :key="i">
        <td
          v-for="(col, j) in row"
          :key="j"
          @mousedown="checkLetter"
          :id="i + '-' + j + '-' + diagram[i][j].letter"
          :ref="i + '-' + j + '-' + diagram[i][j].letter"
          :style="{ background: diagram[i][j].bgr }"
        >
          {{ diagram[i][j].letter }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'mp-find-words2-v2',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      startData: {},
      diagram: [],
      correct: [],
    };
  },
  beforeMount() {
    this.newGame();
  },
  mounted() {},
  methods: {
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    newGame() {
      this.startData = this.startGameConfig.sample[0];
      this.diagram = [];
      this.correct = [];
      for (let i = 0; i < this.startData.diag.length; i++) {
        this.diagram[i] = [];
        for (let j = 0; j < this.startData.diag[i].length; j++) {
          this.diagram[i][j] = this.startData.diag[i][j];
          this.diagram[i][j] = {
            letter: this.startData.diag[i][j],
            bgr: this.startGameConfig.colors.bgr,
            select: false,
          };
        }
      }
      var cor = [];
      this.startData.correct.forEach(function (item, i) {
        item.cord.forEach(function (c, j) {
          var flg = false;
          for (let k = 0; k < cor.length; k++) {
            if (JSON.stringify(c) == JSON.stringify(cor[k])) {
              flg = true;
              break;
            }
          }
          if (!flg) cor.push(c);
        });
      });
      this.correct = cor;
    },
    resetGameAction() {
      this.newGame();
      for (let i = 0; i < this.startData.diag.length; i++) {
        for (let j = 0; j < this.startData.diag[i].length; j++) {
          let id = i + '-' + j + '-' + this.startData.diag[i][j];
          this.$refs[id][0].style.backgroundColor = this.startGameConfig.colors.bgr;
        }
      }
    },
    checkGameAction() {
      var isCorrect = 0;
      var selected = 0;
      for (let i = 0; i < this.diagram.length; i++) {
        for (let j = 0; j < this.diagram[i].length; j++) {
          if (this.diagram[i][j].select) {
            this.correct.forEach(function (item, k) {
              if (JSON.stringify(item) == JSON.stringify([i, j])) {
                isCorrect++;
              }
            });
            selected++;
          }
        }
      }
      if (isCorrect === this.correct.length && isCorrect === selected) {
        for (let i = 0; i < this.startData.correct.length; i++) {
          for (let j = 0; j < this.startData.correct[i].cord.length; j++) {
            let id =
              this.startData.correct[i].cord[j][0] +
              '-' +
              this.startData.correct[i].cord[j][1] +
              '-' +
              this.diagram[this.startData.correct[i].cord[j][0]][this.startData.correct[i].cord[j][1]].letter;
            this.$refs[id][0].style.backgroundColor = this.startData.correct[i].color;
          }
        }
        return true;
      }
      return false;
    },
    checkLetter(a) {
      if (a.target.id) {
        let d = a.target.id.split('-');
        if (!this.diagram[parseInt(d[0])][parseInt(d[1])].select) {
          this.$refs[a.target.id][0].style.backgroundColor = this.startGameConfig.colors.sel;
          this.diagram[parseInt(d[0])][parseInt(d[1])].select = true;
        } else {
          this.$refs[a.target.id][0].style.backgroundColor = this.diagram[parseInt(d[0])][parseInt(d[1])].bgr;
          this.diagram[parseInt(d[0])][parseInt(d[1])].select = false;
        }
      }
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      // // console.log('newStatus', newStatus);
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.game-container {
  display: flex;
  padding-top: 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.game-container table {
  border-collapse: collapse;
  font-weight: bold;
}

.game-container td {
  border: 1px solid black;
  vertical-align: central;
  text-align: center;
  padding: 0.25em 0.5em;
}
</style>
